import { render, staticRenderFns } from "./PlaylistViewMore.vue?vue&type=template&id=d5527ce4&"
import script from "./PlaylistViewMore.vue?vue&type=script&lang=js&"
export * from "./PlaylistViewMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports